import React from 'react'
import { Header, Table } from '../components';

const Transactions = () => {
    return (
        <div className="mainpanel">

            {/* <!-- pageheader --> */}
            <Header />

            <div className="contentpanel">
                <Table />
            </div>

        </div>
    )
}

export default Transactions
